import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

import { filter, take } from 'rxjs';

import { Step1 } from '../step1/step1';
import { Step2 } from '../step2/step2';
import { Step3 } from '../step3/step3';
import { Step4 } from '../step4/step4';
import { Step5 } from '../step5/step5';
import { Step6 } from '../step6/step6';

import { Preventivo } from '../shared/preventivo';

@Component({
  selector: 'app-wizard',
  imports: [
    CommonModule,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    Step6
  ],
  templateUrl: './wizard.html',
  styleUrl: './wizard.css'
})
export class Wizard implements OnInit {
  step = 1;

  steps = [
    '1. Questionario',
    '2. Configurazione beni',
    '3. Richiesta preventivo',
    '4. Dati anagrafici',
    '5. Pagamento',
    '6. Firma'
  ];

  referralCode?: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private preventivo: Preventivo
  ) { }

  ngOnInit(): void {
    // 1) leggi una sola volta i query param per eventuale referral
    this.route.queryParamMap.pipe(take(1)).subscribe(qp => {
      const ref = qp.get('ref');
      if (ref) {
        this.preventivo.setReferral(ref);
        this.referralCode = ref;
      }
    });

    // 2) alla prima lettura dei parametri di route:
    //    se non sei già su /step/1, normalizza e aggiorna l'URL
    this.route.paramMap.pipe(take(1)).subscribe(pm => {
      const stepParam = pm.get('step');
      if (stepParam !== '1') {
        this.router.navigate(['/step', 1], {
          replaceUrl: true,
          queryParams: this.route.snapshot.queryParams
        });
      } else {
        this.step = 1;
      }
    });
  }

  avantiStep() {
    if (this.step < 6) {
      this.step++;
      this.router.navigate(['/step', this.step], {
        queryParamsHandling: 'preserve' // Mantiene i parametri nell'url
      });
    }
  }

  indietroStep() {
    if (this.step > 1) {
      this.step--;
      this.router.navigate(['/step', this.step], {
        queryParamsHandling: 'preserve' // Mantiene i parametri nell'url
      });
    }
  }
}
